import styled from 'styled-components';

export const WrapperPreguntaEncuestaEstrellas = styled.div`
  .estrellasContainer {
    display: flex;
  }

  .estrella {
    width: 50px;
    height: 50px;
    cursor: pointer;
  }

  .estrellaClickeada {
    width: 50px;
    height: 50px;
    cursor: auto;
  }

  .estrellaTexto {
    font-size: 13px;
    color: #5a5a5a;
  }

  @media (max-width: 426px) {
    .estrella {
      width: 40px;
      height: 40px;
    }
  
    .estrellaClickeada {
      width: 40px;
      height: 40px;
    }
  
    .estrellaTexto {
      font-size: 12px;
    }
  }
`;

export default WrapperPreguntaEncuestaEstrellas;
